
import axios from "axios"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"
import { useAuthStore } from "../store/authStore"

interface ParsedQuery {
    [key: string]: string | string[]
}
const useParamsHandler = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams();

    const getPermission = async () => {
        await axios.get(`${(window?.RUNTIME_CONFIG?.REACT_APP_API_ENDPOINT || process.env.REACT_APP_API_ENDPOINT)}/auth/users/me/permissions/`).then((res) => {
            useAuthStore.getState().SetDataPermissionList(res.data.permissions)
        }).catch((e) => { })
    }
    const getParams = (ignore: string[] = []) => {
        const defaultIgnore = ["ordering", "organization"];
        let params = location.search
        const params2 = new URLSearchParams(params);
        const parsed: ParsedQuery = {};

        for (const [key, value] of Array.from(params2.entries())) {
            if (!defaultIgnore.includes(key) && !ignore.includes(key)) {
                parsed[key] = value.split(",");
            }
        }
        delete parsed.page
        delete parsed.ordering

        if (params && params[0] !== "?") {
            params = `?${params}`
        }
        return { params, parsed }
    }
    const setParams = (newParams: string) => {
        const newSearchParams = new URLSearchParams(searchParams); // Create a new instance        
        const ordering = newSearchParams.get('ordering');
        const org = newSearchParams.get('organization');

        navigate({
            pathname: window.location.pathname,
            search: `${newParams || "?"}${ordering ? ("&ordering=" + ordering) : ""}${org ? ("&organization=" + org) : ""}&page=1`,
        }, { replace: true });
    }
    const getParamsPageNumber = () => {
        const page = searchParams.get('page');
        if (page) {
            return parseInt(page, 10);
        }
        return 1;
    }
    const setPageParams = (page: number) => {
        const newSearchParams = new URLSearchParams(searchParams); // Create a new instance
        newSearchParams.set('page', page.toString()); // Set the new value for 'page'
        setSearchParams(newSearchParams); // Update the URL
    }
    const setOrderingParams = (order: string) => {
        const newSearchParams = new URLSearchParams(searchParams); // Create a new instance
        newSearchParams.set('ordering', order); // Set the new value for 'page'
        newSearchParams.set('page', "1");
        setSearchParams(newSearchParams); // Update the URL
    }

    return { getParams, setParams, setPageParams, setOrderingParams, getParamsPageNumber }

}
export default useParamsHandler